export type ProDocumentUploadKey = 'companyRegistration' | 'identityCard' | 'identityCardBack';

type ProDocumentUploadRule = {
	accept: string;
	allowedMimeTypes: Set<string>;
	allowedExtensions: Set<string>;
};

const PDF_RULE: ProDocumentUploadRule = {
	accept: '.pdf,application/pdf',
	allowedMimeTypes: new Set(['application/pdf']),
	allowedExtensions: new Set(['pdf']),
};

const IDENTITY_RULE: ProDocumentUploadRule = {
	accept: '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png',
	allowedMimeTypes: new Set(['application/pdf', 'image/jpeg', 'image/png', 'image/jpg']),
	allowedExtensions: new Set(['pdf', 'jpg', 'jpeg', 'png']),
};

const PRO_DOCUMENT_UPLOAD_RULES: Record<ProDocumentUploadKey, ProDocumentUploadRule> = {
	companyRegistration: PDF_RULE,
	identityCard: IDENTITY_RULE,
	identityCardBack: IDENTITY_RULE,
};

export const getProDocumentUploadAccept = (type: ProDocumentUploadKey) => {
	return PRO_DOCUMENT_UPLOAD_RULES[type].accept;
};

export const isAllowedProDocumentUploadFile = (
	file: File,
	type: ProDocumentUploadKey
) => {
	const rule = PRO_DOCUMENT_UPLOAD_RULES[type];
	const mimeType = file.type.toLowerCase();
	const extension = file.name.split('.').pop()?.toLowerCase() ?? '';

	return rule.allowedMimeTypes.has(mimeType) || rule.allowedExtensions.has(extension);
};
